import React, { useEffect, useState, useRef } from 'react'
import { Subtitles } from './Subtitles'

function SequenceAneme(props) {
  const {
    ttsMessageData,
    ttsPlayStart,
    ttsPlayType,
    onTtsPlayStop,
    showCC,
    skipUnskipComponent,
    priorityActive,
    onSkipError,
    clearTtsPlay,
    hideAnimation,
    onTtsPlaying,
    isCloseClick,
    isReplayHappening,
    isSmartPaper,
    onKnovoHelpSelected,
    onSkipWhenNotPlaying,
    isDelayRunning,
    getTutorTalking,
    smartPaperData,
    currentOSName,
    knovoHelpClick,
    displayWlakthrough,
    readmoreUrl,
    onReadmoreClick,
    isHintDisplay,
    onHintIconChange,
    isAiChatBotVisible,
    muteClicked,
    muteStatus,
    FollowTheFlow,
    isCanvas
  } = props
  const [lineNumber, setLineNumber] = useState(-1)
  const [speechDataArray, setSpeechDataArray] = useState([])
  const [showTutorial, setShowTutorial] = useState(false)
  const [isSeqPlaying, setIsSeqPlaying] = useState(false)
  const [isHideSubtitle, setIsHideSubtitle] = useState(false)
  const isForceStop = useRef()
  const isSeqPause = useRef()

  const [completedAllCompData, setCompletedAllCompData] = useState([])
  const [isNewSeqData, setIsNewSeqData] = useState(false)

  const [isBotMute, setIsBotMute] = useState(false)
  const [isMuteClick, setIsMuteClick] = useState(false)

  useEffect(() => {
    if (hideAnimation) {
      setShowTutorial(false)
    }
  }, [hideAnimation])

  useEffect(() => {
    if (ttsPlayType === 'sequence') {
      setIsNewSeqData(true)
    } else {
      setIsNewSeqData(false)
    }
  }, [ttsMessageData])

  useEffect(() => {
    if (isCloseClick) {
      isForceStop.current = true
      setLineNumber(ttsMessageData.length)
      setShowTutorial(false)
      setIsSeqPlaying(false)
      window.speechSynthesis.cancel()
    }
  }, [isCloseClick])

  //Start the first line of introduction
  useEffect(() => {
    if (ttsPlayStart) {
      if (ttsPlayType === 'hint' && ttsMessageData && ttsMessageData !== '') {
        setShowTutorial(true)
        setIsSeqPlaying(true)
        speakBackground(ttsMessageData)
        setLineNumber(-1)
      } else if (ttsMessageData && ttsMessageData.length > 0) {
        setLineNumber(0)
        setSpeechDataArray(ttsMessageData)
      } else {
        setIsSeqPlaying(false)
        onTtsPlayStop()
      }
    }
  }, [ttsPlayStart])

  useEffect(() => {
    if (ttsPlayType === 'sequence') {
      setSpeechDataArray(ttsMessageData)
    }
  }, [ttsPlayType])

  useEffect(() => {
    if (lineNumber >= 0) {
      if (speechDataArray[lineNumber] && speechDataArray[lineNumber] !== '') {
        setIsSeqPlaying(true)
        isForceStop.current = false
        isSeqPause.current = false
        setShowTutorial(true)
        speakBackground(speechDataArray[lineNumber])
      } else if (speechDataArray[lineNumber] === '') {
        setTimeout(() => {
          finishActions()
        }, 1000)
      } else if (!speechDataArray[lineNumber]) {
        setIsSeqPlaying(false)
        onTtsPlayStop()
      }
    }
  }, [lineNumber])

  useEffect(() => {
    if (isMuteClick) {
      if (lineNumber >= 0) {
        if (speechDataArray[lineNumber] && speechDataArray[lineNumber] !== '') {
          setIsSeqPlaying(true)
          isForceStop.current = false
          isSeqPause.current = false
          setShowTutorial(true)
          speakBackground(speechDataArray[lineNumber])
        } else if (speechDataArray[lineNumber] === '') {
          setTimeout(() => {
            finishActions()
          }, 1000)
        } else if (!speechDataArray[lineNumber]) {
          setIsSeqPlaying(false)
          onTtsPlayStop()
        }
      }
      setIsMuteClick(false)
    }
  }, [isMuteClick])

  useEffect(() => {
    if (lineNumber >= 0) {
      let completedTextData = []
      if (smartPaperData) {
        let inputRows = smartPaperData.InputRows
        let multipleComponentsData = smartPaperData.InputRows.filter(
          (e) => e.PluginName === 'Dropdown' || e.PluginName === 'InputAnswer'
        )
        let multipleComponentsDataArray = []
        if (multipleComponentsData.length > 0) {
          multipleComponentsData.map((item) => {
            item.Options.map((values) => {
              multipleComponentsDataArray.push(values)
            })
          })
        }
        let allData = [...inputRows].concat([...multipleComponentsDataArray])
        let sortedData = allData.sort((a, b) => a.Priority - b.Priority)
        if (sortedData && sortedData.length > 0) {
          for (const key in sortedData) {
            if (sortedData[key].Priority < priorityActive) {
              let sequenceData = sortedData[key].SpeechData
              for (let index = 0; index <= sequenceData.length; index++) {
                if (sequenceData[index] && sequenceData[index] !== '') {
                  completedTextData.push(sequenceData[index])
                }
              }
            } else if (sortedData[key].Priority === priorityActive) {
              let sequenceData1 = sortedData[key].SpeechData
              for (let index1 = 0; index1 <= lineNumber; index1++) {
                if (sequenceData1[index1] && sequenceData1[index1] !== '') {
                  completedTextData.push(sequenceData1[index1])
                }
              }
            }
          }
          if (ttsPlayType === 'sequence' && isNewSeqData) {
            setCompletedAllCompData(completedTextData)
          }
        }
      }
    }
  }, [lineNumber, priorityActive])

  const cancelActions = () => {
    window.speechSynthesis.cancel()
    setLineNumber(-1)
    setIsSeqPlaying(false)
    clearTtsPlay()
  }

  const cancelActionsMute = () => {
    window.speechSynthesis.cancel()
    setIsSeqPlaying(false)
    clearTtsPlay()
  }

  const finishActions = () => {
    if (ttsPlayType === 'hint') {
      setIsSeqPlaying(false)
      onTtsPlayStop()
    } else {
      if (isForceStop.current && !isSeqPause.current) {
        setLineNumber(ttsMessageData.length)
        onTtsPlayStop()
      } else {
        setLineNumber((lineNumber) => lineNumber + 1)
      }
    }
  }

  function stopTtsPlaying() {
    window.speechSynthesis.cancel()
    if (ttsPlayType === 'hint') {
      setIsSeqPlaying(false)
      setShowTutorial(false)
      setLineNumber(-1)
      onTtsPlayStop()
    } else {
      setLineNumber(ttsMessageData.length)
      if (ttsPlayType === 'feedback') {
        setIsSeqPlaying(false)
        setShowTutorial(false)
      }
    }
  }

  function configureSpeech(
    text,
    voiceURI,
    volume = 1,
    rate = 0.8,
    pitch = 0.9
  ) {
    const speechApi = new SpeechSynthesisUtterance()
    const voices = window.speechSynthesis.getVoices()

    speechApi.voice =
      voices.find((voice) => voice.voiceURI === voiceURI) || voices[0] // Fallback to first voice
    speechApi.volume = volume
    speechApi.rate = rate
    speechApi.pitch = pitch
    speechApi.text = text
    speechApi.lang = 'en-US'
    return speechApi
  }

  function speakBackground(text) {
    // Trigger the TTS playing callback if available
    if (typeof onTtsPlaying === 'function') {
      onTtsPlaying()
    }

    // Handle "hint" play type state changes
    if (ttsPlayType === 'hint') {
      isForceStop.current = false
      isSeqPause.current = false
      setIsSeqPlaying(true)
    }

    // Cancel ongoing speech to avoid conflicts
    if (window.speechSynthesis.speaking || window.speechSynthesis.pending) {
      window.speechSynthesis.cancel()
    }

    // Delay to reset the speech engine
    setTimeout(() => {
      const voiceURI =
        currentOSName === 'Chrome OS'
          ? 'Chrome OS US English 8'
          : 'Google US English'
      const volume = muteStatus ? 0 : 1
      const speechApi = configureSpeech(text, voiceURI, volume)

      // Handle end of speech
      speechApi.onend = function () {
        if (!isForceStop.current) {
          finishActions()
        }
      }

      // Error handling
      speechApi.onerror = function (error) {
        console.error('SpeechSynthesis error:', error)
      }

      // Speak the text
      window.speechSynthesis.speak(speechApi)
    }, 100)
  }

  useEffect(() => {
    if (isSeqPlaying) {
      getTutorTalking(false)
    } else {
      getTutorTalking(true)
    }
  }, [isSeqPlaying])

  useEffect(() => {
    if (muteClicked) {
      turn_Off_On_Sound(muteStatus)
    }
  }, [muteClicked])

  function turn_Off_On_Sound(isBotMute) {
    if (isBotMute) {
      setIsNewSeqData(true)
      isForceStop.current = true
      isSeqPause.current = true
      cancelActionsMute()
      setTimeout(() => {
        setIsSeqPlaying(true)
        setIsMuteClick(true)
      }, 1000)
    } else {
      setIsNewSeqData(true)
      isForceStop.current = true
      isSeqPause.current = true
      cancelActionsMute()
      setTimeout(() => {
        setIsSeqPlaying(true)
        setIsMuteClick(true)
      }, 1000)
    }
  }

  return (
    <span className='knovaBotSeqView'>
      <Subtitles
        isTutor={ttsPlayType === 'hint' ? false : true}
        text={
          isSmartPaper
            ? ttsPlayType === 'hint'
              ? ttsMessageData
              : speechDataArray
            : ttsMessageData
        }
        lineNumber={lineNumber}
        showCC={showCC}
        botType={'sequence'}
        ttsPlayType={ttsPlayType}
        isSeqPlaying={isSeqPlaying}
        isReplayHappening={isReplayHappening}
        isSmartPaper={isSmartPaper}
        knovoHelpClick={knovoHelpClick}
        displayWlakthrough={displayWlakthrough}
        tutorTalking={isSeqPlaying}
        readmoreUrl={readmoreUrl}
        onReadmoreClick={(status) => onReadmoreClick(status)}
        onFrwdSkipClick={() => {
          if (priorityActive >= Object.keys(skipUnskipComponent).length) {
            onSkipError(true)
          } else {
            if (skipUnskipComponent[priorityActive]) {
              if (isDelayRunning) {
                onSkipWhenNotPlaying()
              } else {
                isForceStop.current = true
                isSeqPause.current = false
                stopTtsPlaying()
              }
            } else {
              onSkipError(false)
            }
          }
        }}
        onStopClick={() => {
          if (ttsPlayType === 'hint') {
            if (isSeqPlaying) {
              isForceStop.current = true
              isSeqPause.current = true
              stopTtsPlaying()
            } else {
              isForceStop.current = false
              isSeqPause.current = false
              setShowTutorial(true)
              setIsSeqPlaying(true)
              speakBackground(ttsMessageData)
              setLineNumber(-1)
            }
          } else if (ttsPlayType === 'feedback') {
            isForceStop.current = true
            isSeqPause.current = false
            stopTtsPlaying()
          } else {
            setIsNewSeqData(false)
            if (isSeqPlaying) {
              isForceStop.current = true
              isSeqPause.current = true
              cancelActions()
            } else {
              setIsSeqPlaying(true)
              setLineNumber(0)
            }
          }
        }}
        onHideSubtitle={(isHideSubtitle) => {
          setIsHideSubtitle(isHideSubtitle)
        }}
        isHintDisplay={isHintDisplay}
        onHintIconClicked={onHintIconChange}
        isAiChatBotVisible={isAiChatBotVisible}
        completedAllCompData={completedAllCompData}
        muteClicked={muteClicked}
        muteStatus={muteStatus}
        isCanvas={isCanvas}
      />
    </span>
  )
}

export { SequenceAneme }
